<div
  class="flex gap-2"
  [ngClass]="{ 'flex-col items-start justify-center': analyticsMode(), 'items-center': !analyticsMode() }"
>
  @if (icon() && !socialIcon() && !isViewMode()) {
    <app-icon
      [src]="icon()!"
      [size]="iconSize()"
      [color]="iconColor() ?? 'var(--shikenso-purple-base)'"
      [class.opacity-[24%]]="disabled()"
    />
  }

  @if (socialIcon()) {
    <app-social-badge [class.opacity-[24%]]="disabled()" [type]="socialIcon()!" [size]="40" [iconSize]="20" />
  }

  <div class="flex items-center gap-3">
    <div class="flex flex-col items-start justify-center gap-1">
      @if (!isEditMode()) {
        <div class="flex items-center gap-1 min-w-0">
          <span
            matTooltip
            matTooltipClass="max-w-unset"
            class="text-ellipsis line-clamp-1"
            [ngClass]="fontClasses()"
            [style.max-width.px]="maxWidth()"
            [defaultTooltip]="subtitle()"
            [appTextClampTooltip]="control()?.value ?? title() ?? ''"
            [class.opacity-[24%]]="disabled()"
          >
            {{ prioritizeTitle() ? title() : (control()?.value ?? title()) }}
          </span>

          @if (control() && !isViewMode() && !readonly()) {
            <button
              mat-icon-button
              type="button"
              class="mat-secondary-transparent-button-color mat-tiny-icon-button !p-0"
              (click)="onEditModeChange($event, true)"
              [disabled]="disabled()"
              [class.!opacity-[24%]]="disabled()"
            >
              <app-icon src="/icons/edit.svg" alt="edit" [size]="16" />
            </button>
          }

          @if (infoTooltip() && !creatorBriefingMode()) {
            <app-icon
              src="/icons/info-circle.svg"
              alt="info-circle"
              matTooltipPosition="above"
              matTooltipClass="justified-tooltip"
              [size]="16"
              [matTooltip]="infoTooltip()"
            />
          }
        </div>
      } @else if (control() && !isViewMode() && !readonly()) {
        <div class="flex items-center gap-2">
          <mat-form-field class="custom-form !min-w-40" (click)="$event.stopPropagation()">
            <input
              matInput
              type="text"
              [formControl]="control()!"
              [readonly]="disabled()"
              (click)="$event.stopPropagation()"
              (keydown.Space)="$event.stopImmediatePropagation()"
              (keydown.Enter)="onFormSave($event)"
              (keydown.Escape)="onFormCancel($event)"
            />
            <mat-error [control]="control()!" />
          </mat-form-field>
          <div class="flex items-center gap-2">
            <button
              mat-icon-button
              type="button"
              class="mat-secondary-transparent-button-color"
              [disabled]="disabled()"
              (click)="onFormSave($event)"
            >
              <app-icon src="/icons/check.svg" alt="check" class="w-3 h-3" />
            </button>
            <button
              mat-icon-button
              type="button"
              class="mat-secondary-transparent-button-color"
              [disabled]="disabled()"
              (click)="onFormCancel($event)"
            >
              <app-icon src="/icons/close.svg" alt="close" class="w-3 h-3" />
            </button>
          </div>
        </div>
      }

      @if (
        !isViewMode() && subtitle() && ((hideSubtitleWhenEditing() && !isEditMode()) || !hideSubtitleWhenEditing())
      ) {
        <span class="text-xs text-shikenso-gray-600">
          {{ subtitle() }}
        </span>
      }
    </div>

    @if (showRequiredBadge()) {
      <div
        class="flex items-center rounded-full px-2 py-0.5 border border-shikenso-outlier-base bg-shikenso-outlier-light"
      >
        <span class="text-shikenso-outlier-base text-[10px] leading-none">
          {{ 'shared.required' | translate }}
        </span>
      </div>
    }
  </div>

  @let canShowManualDeliverableStatus =
    manualDeliverableStatusConfig() && manualDeliverableStatusConfig()?.statusVisible;

  @if (canShowManualDeliverableStatus) {
    <div class="flex items-center">
      <app-manual-deliverable-status
        [manualDeliverableStatus]="manualDeliverableStatusConfig()!.manualDeliverableStatus"
        [deliverableCard]="manualDeliverableStatusConfig()!.deliverableCard"
        [actionsVisible]="manualDeliverableStatusConfig()!.actionsVisible"
        [statusVisible]="manualDeliverableStatusConfig()!.statusVisible"
        [creatorBriefingMode]="manualDeliverableStatusConfig()!.creatorBriefingMode"
        [exportMode]="manualDeliverableStatusConfig()!.exportMode"
        [hideTooltip]="hideManualDeliverableStatusTooltip()"
      />
    </div>
  }

  @if (analyticsMode()) {
    <div class="flex items-center gap-1 mt-5 mb-3">
      <span class="text-sm font-bold">
        {{ 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.objective' | translate }}
      </span>
      <span class="text-xs text-shikenso-purple-base-40">
        {{ 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.requiredByCampaign' | translate }}
      </span>
    </div>
  }
</div>
